import script from "./StartOwnSubscriptionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StartOwnSubscriptionDialog.vue?vue&type=script&setup=true&lang=js"

import "./StartOwnSubscriptionDialog.vue?vue&type=style&index=0&id=54b1f15b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b1f15b"]])

export default __exports__